import { ArrowDropDown } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { toast as toastFn } from 'react-toastify';
import { CourseAccordian } from './CourseAccordian';
import Button from '../../components/Button';
import { useParams } from 'react-router-dom';
import { generateUUID } from '../../utils';



export const DiagnosticT2 = ({ courseList, diagnosticT1, diagnosticT2, setDiagnosticT2, isMapped, isSubmit, setIsSubmit }) => {

    const { id } = useParams();
    const [diagnosticT2List, setDiagnosticT2List] = useState([]);

    useEffect(() => {
        // Filter assessments with courseId and map to required format
        if (id && diagnosticT2) {
            setDiagnosticT2List(diagnosticT2)
        } else {
            const transformedAssessments = diagnosticT1?.nextLevelAssessments
                ?.filter((assessment) => assessment.courseId)
                ?.map((assessment) => ({
                    id: assessment.id,
                    courseId: assessment.courseId,
                })) || [];

            // Update state
            // setDiagnosticT2(transformedAssessments);
            setDiagnosticT2List(transformedAssessments)
        }
    }, [diagnosticT1, diagnosticT2, id]);

    const validateData = () => {

        // Filter diagnosticT1.nextLevelAssessments to only include items with courseId
        const filteredAssessments = diagnosticT1?.nextLevelAssessments?.filter((assessment) => assessment.courseId) || [];

        // Check if the length of diagnosticT2 matches the filtered assessments length
        if (diagnosticT2 && diagnosticT2.length == filteredAssessments.length) {
            setIsSubmit(true)
        } else {
            setIsSubmit(false)
        }

    };

    useEffect(() => {
        validateData();
    }, [diagnosticT1, diagnosticT2List]);

    return (
        <Box>
            <Typography
                align="center"
                variant="h1"
                sx={{
                    margin: 1,
                    fontWeight: '700',
                    lineHeight: '1.5',
                    fontSize: '1rem',
                    color: isMapped ? "#fff" : 'primary.blue',
                    background: isMapped ? '#403e75' : '#00000014',
                    padding: 1,
                    borderRadius: 1
                }}>Diagnostic Test - 2
            </Typography>
            <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
                <Grid item xs={12}>

                    {(!diagnosticT2) ? (
                        <Typography align="center" sx={{ fontSize: '1rem', color: 'grey' }}>
                            Loading, please wait...
                        </Typography>
                    ) : (
                        diagnosticT2List?.map((item) => {
                            return (
                                <React.Fragment key={`${item?.id}-${item?.courseId}`}>
                                    <CourseAccordian
                                        item={item}
                                        courseList={courseList}
                                        diagnosticT2={diagnosticT2}
                                        setDiagnosticT2={setDiagnosticT2}
                                        diagnosticT1={diagnosticT1}
                                    />
                                </React.Fragment>
                            );
                        })
                    )}

                </Grid>
            </Grid>
        </Box >
    )
}

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '1em'
    },
    gridContainer: {
        mt: 1,
        display: 'flex'
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '30px',
        height: '30px',
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
        borderRadius: '0',
        minWidth: '30px'
    },
    hiddenInput: {
        display: 'none',
    },
    actionBtnItem: {
        marginLeft: '5px',
        marginRight: '5px',
        cursor: 'pointer',
        display: 'flex',
        gap: '20px',
        alignItems: 'center'
    },
    row: {
        padding: '5px 16px'
    }
}
